import { useIntl } from 'react-intl';
import { HEADER_COLUMN_HEIGHT } from '@rossum/components/data-grid/styles';
import { IconCircleOff, IconCloudDownload } from '@rossum/ui/icons/tabler';
import { alpha, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { absoluteMaxSizeStyles } from './helpers';

type DragOverlayProps = {
  canUploadToQueue: boolean;
};

export const DragOverlay = ({ canUploadToQueue }: DragOverlayProps) => {
  const intl = useIntl();
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        background: theme =>
          alpha(
            theme.palette.mode === 'dark'
              ? theme.palette.common.black
              : theme.palette.common.white,
            0.75
          ),
        border: theme => `2px dashed ${theme.palette.primary.main}`,
        borderRadius: borderRadius('m'),
        zIndex: theme => theme.zIndex.drawer,
        ...absoluteMaxSizeStyles,
        top: `${HEADER_COLUMN_HEIGHT}px`,
      }}
    >
      {canUploadToQueue ? (
        <>
          <SvgIcon fontSize="xLarge" color="secondary">
            <IconCloudDownload />
          </SvgIcon>
          <Typography variant="subtitle2" color="text.secondary">
            {intl.formatMessage({
              id: 'containers.annotationList.dropFiles', // TODO: mission-simplified-dashboard: rewrite translation key
            })}
          </Typography>
        </>
      ) : (
        <>
          <SvgIcon fontSize="xLarge" color="secondary" sx={{ mb: 1 }}>
            <IconCircleOff />
          </SvgIcon>
          <Typography variant="subtitle2" color="text.secondary">
            {intl.formatMessage({
              id: 'containers.settings.queues.uploadDisabled',
            })}
          </Typography>
        </>
      )}
    </Stack>
  );
};
